import React, { useState, useEffect } from 'react';
import { IconFont } from '@features/common';
import { Popconfirm } from 'antd';
import './SFCItemOption.less';

export interface ISFCItemOptionProps {
  className?: string;
  handleEdit?: () => void;
  handleRemove: () => void;
}
type Props = ISFCItemOptionProps;

export function SFCItemOption(props: Readonly<Props>) {
  const { handleEdit, handleRemove, className = '' } = props;

  const stop = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
  };

  return (
    <div className={`common-presenter k-common-item-option ${className}`} onClick={stop}>
      {handleEdit && (
        <>
          <div className="option-item option-edit" onClick={handleEdit}>
            <IconFont type="icon-edit1" className="option-ico" />
            编辑
          </div>
          <div className="option-line" />
        </>
      )}
      <Popconfirm title="确认删除？" onConfirm={handleRemove} okText="确认" cancelText="取消">
        <div className="option-item option-delete">
          <IconFont type="icon-ashcan" className="option-ico" />
          删除
        </div>
      </Popconfirm>
    </div>
  );
}

export default SFCItemOption;
